import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';

declare const window;

@Component({
  selector: 'app-turns-form-resume-card',
  templateUrl: './turns-form-resume-card.component.html',
  styleUrls: ['./turns-form-resume-card.component.scss']
})
export class TurnsFormResumeCardComponent implements OnInit, OnDestroy {

  @Input() form;
  @Input() viewDisposition;
  showCopyMessage: boolean;
  updateStatusLocationSubscription: Subscription;
  deleteFormSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private dialog: MatDialog) {
                this.showCopyMessage = false;
              }

  ngOnInit() {
  }

  public toggleStatus() {
    this.updateStatusLocationSubscription = this.formsTurnsService.updateStatusForm(this.form.InternalId).subscribe(
      (res) => {
        this.form.Active = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN') && (e.target.tagName !== 'BUTTON') && (e.target.tagName !== 'I')) {
      this.router.navigate(['../form', this.form.InternalId], {relativeTo: this.activatedRoute.parent});
    }
  }

  public deleteForm() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['turns-page.delete location', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteFormSubscription = this.formsTurnsService.deleteForm(this.form.InternalId).subscribe(
          (res) => {
            this.formsTurnsService.refreshForms();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  public viewForm(formUrl) {
    window.open(formUrl);
  }

  public copyUrlToClipboard(formUrl) {
    const ta = document.createElement('textarea');
    ta.value = formUrl;
    ta.setAttribute('readonly', '');
    ta['position'] = 'absolute';
    ta['left'] = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    this.showCopyMessage = true;
    setTimeout(
      () => {
        this.showCopyMessage = false;
      }
    , 2000);
  }

  ngOnDestroy() {
    if (this.updateStatusLocationSubscription) { this.updateStatusLocationSubscription.unsubscribe(); }
    if (this.deleteFormSubscription) { this.deleteFormSubscription.unsubscribe(); }
  }
}
